import {  graphql, useStaticQuery } from 'gatsby'
const produpdate = ({src}) => {

const data = useStaticQuery(graphql`query produpdateQuery {
    allGhostPost(
        sort: {published_at: DESC}
        filter: {tags: {elemMatch: {name: {eq: "#prod-update"}}}}
    ) {
        nodes {
        id
        title
        slug
        tags {
            name
            slug
        }
        feature_image
        excerpt
        }
    }
}`)
    const items = []
    {data.allGhostPost.nodes.map((post, index) => {
        const url = `/product-updates/${post.slug}/`

        items.push(
            <div className="col-12 col-md-4 mb-4 produpd-list" key={index}>
                <div className="bg-white brad-16 p-4">
                    <a href={ url } title={ post.title }>
                    <div className="d-flex justify-content-end align-items-center position-relative mb-3">
                        <img
                        className="img-responsive brad-16"
                        src={ post.feature_image } alt={ post.title}
                        />
                    </div>
                    <p className="section-para mb-0">
                        <strong>
                        { post.title }
                        </strong>
                    </p>
                    </a>
                </div>
            </div>
        )
    })}
    return (<>
        <section className="bg-dark hero-bg position-relative partner-hero-wrapper1 about-pattern-vfit">
            <div className="container custom_container d-flex justify-content-center align-items-center p0 m-d-block">
            <div className="col-12 partner-hero-title">
                <div className="prod-updates">
                <h1 className="font-weight-semibold hero-heading">What's new?</h1>
                <p className="hero-para font-weight-semibold">
                    Staying Ahead of the Curve: We are constantly improving our product to enhance <br />
                    your wellness journey. Check out our latest product updates and features.
                </p>
                <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                    <a href="/request-demo/" className="vfitcompanycta arrowbtn-img">
                    Let's Talk
                    </a>
                </div>
                </div>
            </div>
            </div>
        </section>
        <section className="position-relative gray-gradient-bg py-5">
            <div className="container custom_container">
                <div className="col-12 px-0">
                    <div className="row">
                        {items}
                    </div>
                </div>
            </div>
        </section>
    </>)
}

export default produpdate

